import styled from "@emotion/styled";

export const CardBase = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius(4)};
  border: 1px solid ${({ theme }) => theme.colors.border.tertiary};
  background: ${({ theme }) => theme.colors.background.secondary};
  backdrop-filter: blur(1.5px);
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
